import { Dispatch, Action } from 'redux';

import { isRejectedWithValue } from '@reduxjs/toolkit';

import { baseApi } from 'api/api-base';
import { NOTIFICATION_TYPE, STATUS_CODES } from 'types/general.types';
// import {
//   showErrorNotification,
//   showSuccessNotification,
//   showWarningNotification,
// } from 'store/slices/notification-slice';
import { NOTIFICATIONS } from 'constants/notifications';

type ApiAction = Action & {
  payload: {
    status: number;
    data?: {
      error?: { message?: string };
    };
  };
  meta: {
    baseQueryMeta: {
      response: {
        status: STATUS_CODES;
      };
    };
    arg: {
      endpointName: keyof typeof baseApi.endpoints;
      originalArgs: { silent?: boolean };
    };
  };
};

// const NOTIFICATION_ACTION_MAP: Record<string, (msg: string) => (dispatch: Dispatch) => void> = {
//   [NOTIFICATION_TYPE.WARNING]: showWarningNotification,
//   [NOTIFICATION_TYPE.ERROR]: showErrorNotification,
//   [NOTIFICATION_TYPE.SUCCESS]: showSuccessNotification,
// };

const GLOBAL_ERROR_MAP = {
  [STATUS_CODES.SERVER_ERROR]: {
    notificationType: NOTIFICATION_TYPE.ERROR,
    message: NOTIFICATIONS.SERVER_ERROR,
  },
  [STATUS_CODES.BAD_REQUEST]: {
    notificationType: NOTIFICATION_TYPE.ERROR,
    message: NOTIFICATIONS.BAD_REQUEST,
  },
  [STATUS_CODES.DEPENDENCY_ERROR]: {
    notificationType: NOTIFICATION_TYPE.ERROR,
    message: NOTIFICATIONS.DEPENDENCY_ERROR,
  },
  [STATUS_CODES.NOT_FOUND]: {
    notificationType: NOTIFICATION_TYPE.ERROR,
    message: NOTIFICATIONS.NOT_FOUND,
  },
  [STATUS_CODES.FORBIDDEN]: {
    notificationType: NOTIFICATION_TYPE.ERROR,
    message: NOTIFICATIONS.FORBIDDEN,
  },
  [STATUS_CODES.UNAUTHORIZED]: {
    notificationType: NOTIFICATION_TYPE.ERROR,
    message: NOTIFICATIONS.UNAUTHORIZED,
  },
  [STATUS_CODES.SUCCESS]: {
    notificationType: NOTIFICATION_TYPE.ERROR,
    message: NOTIFICATIONS.RESPONSE_ERROR,
  },
};
export const apiNotificationsMiddleware =
  // ({ dispatch }: { dispatch: Dispatch<any> }) =>
  () => (next: Dispatch<ApiAction>) => (action: ApiAction) => {
    if (isRejectedWithValue(action)) {
      // if (action?.payload?.data?.error?.message) { disabled for now
      //   dispatch(showErrorNotification(action?.payload?.data?.error?.message));
      //   return next(action);
      // }
      const notificationItem = GLOBAL_ERROR_MAP[action?.meta?.baseQueryMeta?.response?.status];
      if (notificationItem) {
        // dispatch(NOTIFICATION_ACTION_MAP?.[notificationItem?.notificationType]?.(notificationItem?.message));
        return next(action);
      }
      // commented by Vlad.K - mock wallet data
      // dispatch(showErrorNotification(NOTIFICATIONS.RESPONSE_ERROR));
      // end of commented by Vlad.K - mock wallet data
    }
    return next(action);
  };
